<template>
    <div class="post">
        <div v-if="loading" class="loading">
            Loading...
        </div>
        <div v-if="error" class="notification is-light">
            <b>{{ error | capitalize }}</b>
            <img src="../assets/notfound.svg">
        </div>
        <div v-if="post" class="box content blogpost">
            <nav class="level">
                <!-- Left side -->
                <div class="level-left">
                    <div class="level-item">
                        <h2 v-cloak class="title is-4">{{ post.title | capitalize }}</h2>
                    </div>
                </div>
                <!-- Right side -->
                <div class="level-right">
                    <span title="publié le" class="has-text-grey"><i class="fas fa-clock"></i>{{post.datepost | formatDate}}</span>
                </div>
            </nav>
            <img alt="img" :src="post.image.path" width="280" @error="imageUrlAlt">
            <p v-html="post.content"></p>
            <div class="has-text-centered">
                <social-sharing v-bind:url="curr_path+'/post/'+ post._id" v-bind:hashtags="hashtag" v-bind:title="post.title+' 👉 '" inline-template>
                    <div>
                        <network network="facebook">
                            <b-icon icon="facebook"></b-icon>
                        </network><span style="visibility: hidden;">|||</span>
                        <network network="twitter">
                            <b-icon icon="twitter"></b-icon>
                        </network>
                    </div>
                </social-sharing>
            </div>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
var SocialSharing = require('vue-social-sharing');

export default {
    data: function() {
        return {
            loading: true,
            post: null,
            error: null,
            curr_path: window.location.origin,
            hashtag: this.$share_hashtag,
        }
    },
    components: {
        SocialSharing
    },
    name: 'Post',
    props: {
        msg: String
    },
    created() {
        this.fetchData()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        imageUrlAlt(event) {
            event.target.src = "https://buefy.org/static/img/placeholder-1280x960.png"
        },
        fetchData() {
            this.error = this.post = null
            this.loading = true
            var vm = this
            //var fetchurl = this.$api_url_posts
            var fetchurl = this.$api_url_posts+'&limit=1&sort[datepost]=-1&populate=1&filter[_id]='+vm.$route.params.id
            axios({
                    method: 'get',
                    url: fetchurl
                    /*
                    method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        filter: { _id: vm.$route.params.id },
                        //fields: {fieldA:1},
                        limit: 1,
                        sort: { datepost: -1 },
                        populate: 1, // resolve linked collection items
                        lang: 'fr' // return normalized language fields (fieldA_de => fieldA)

                    })*/
                }).then(function(response) {
                    vm.loading = false
                    if (response.data.entries.length > 0) {
                        vm.post = response.data.entries[0]
                        vm.error = null
                    } else {
                        vm.post = null
                        vm.error = 'page introuvable'
                    }
                })
                .catch(function() {
                    //console.log("Erreur ! Impossible d'accéder à l'API." + error)
                    vm.error = 'page introuvable'
                })

        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blogpost {
    border-left: 4px solid hsl(141, 53%, 53%);
}
</style>